function clearErrors(input) {
  const formGroup = input.closest(".form__group")

  if (!formGroup) {
    return
  }

  formGroup.classList.remove("form__group--error")

  const error = formGroup.querySelector(".form__error")

  if (error) {
    error.remove()
  }
}

function setButtonState(input) {
  const button = input.closest("form").querySelector("button")

  if (!button) {
    return
  }

  button.disabled = input.value.length === 0
}

function initDiscountForm() {
  const inputs = document.querySelectorAll('.discount-form input[type="text"]')

  for (const input of inputs) {
    input.addEventListener("input", () => {
      clearErrors(input)
      setButtonState(input)
    })
  }
}

window.initDiscountForm = initDiscountForm

window.addEventListener("DOMContentLoaded", () => {
  initDiscountForm()
})
